{
    "NAME": "Modalità dispositivo",
    "DeviceModal_AddTitle": "Aggiungi dispositivo",
    "DeviceModal_ChangeTitle": "Cambia dispositivo",
    "DeviceModal_ViewTitle": "Visualizza dispositivo",
    "DeviceModal_PromptMessage": "Sono presenti modifiche al dispositivo non salvate. Uscire senza salvare?",
    "DeviceModal_PromptConfirm": "Uscita",
    "DeviceModal_PromptCancel": "Cancellare",
    "DeviceModal_Tab_General": "Dettagli",
    "DeviceModal_Tab_Advanced": "Avanzato",
    "DeviceModal_Tab_Monitoring": "Monitoraggio",
    "DeviceModal_Tab_DeviceMembers": "Membri del dispositivo",
    "DeviceModal_Tab_AgentMembers": "Membri agenti",
    "DeviceModal_Tab_DnisMembers": "DNS",
    "DeviceModal_Tab_LinkedEntities": "Entità collegate",
    "DeviceModal_Loading": "Caricamento...",
    "DeviceModal_Button_Close": "Vicino",
    "DeviceModal_Button_Cancel": "Cancellare",
    "DeviceModal_Button_Save": "Salva",
    "DeviceModal_RequestFailed": "Richiesta non riuscita",
    "DeviceModal_General_IdentifierGuid": "Identificativo (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Assegnazione automatica]",
    "DeviceModal_General_GuidPendingHelp": "L'identificativo viene assegnato dopo il salvataggio del dispositivo.",
    "DeviceModal_General_DeviceNumber": "Numero del dispositivo",
    "DeviceModal_General_DeviceNumberRequired": "È richiesto il numero del dispositivo.",
    "DeviceModal_General_Description": "Descrizione",
    "DeviceModal_General_DescriptionRequired": "È necessaria una descrizione",
    "DeviceModal_General_DeviceType": "Tipo di dispositivo",
    "DeviceModal_General_DeviceTypeRequired": "È richiesto il tipo di dispositivo",
    "DeviceModal_General_Partition": "Partizione",
    "DeviceModal_General_PartitionRequired": "È necessaria una partizione",
    "DeviceModal_General_None": "Nessuno",
    "DeviceModal_General_IDOnTelSys": "ID sul server di telefonia",
    "DeviceModal_General_IDOnTelSys_Broadworks": "ID utente BroadWorks",
    "DeviceModal_General_IDOnTelSys_Webex": "ID utente per le chiamate Webex",
    "DeviceModal_General_IDOnTelSys_MsTeams": "ID utente MSTeams",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID sul server di telefonia",
    "DeviceModal_General_IDOnTelSys_M6": "OID sul server telefonico",
    "DeviceModal_General_IDOnTelSysOwner": "ID del gruppo proprietario",
    "DeviceModal_General_IDOnTelSysDivision": "Dipartimento proprietario (percorso completo)",
    "DeviceModal_General_InternalExtension": "Indirizzo di chiamata interno",
    "DeviceModal_General_TelSysUserID": "ID utente del server di telefonia",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Cisco Common Identity",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "Nome principale utente (URN)",
    "DeviceModal_General_TelSysPassword": "Password del server di telefonia",
    "DeviceModal_General_TelSysMonitorPassword": "Password del monitor",
    "DeviceModal_General_PrimaryEmail": "Indirizzo email principale",
    "DeviceModal_General_UpdateExistingItems": "Aggiorna gli elementi esistenti se vengono rilevati duplicati.",
    "DeviceModal_Monitoring_OverrideMonitoring": "Monitoraggio di override (non monitorato)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Disabilita il monitoraggio in tempo reale",
    "DeviceModal_Members_DeviceNumber": "Numero del dispositivo",
    "DeviceModal_Members_Description": "Descrizione",
    "DeviceModal_Members_AgentNumber": "Numero dell'agente",
    "DeviceModal_Members_Actions": "Azioni",
    "DeviceModal_Members_Add": "Aggiungi membro",
    "DeviceModal_Members_AddHotkey": "Aggiungi membro (Ctrl+Invio)",
    "DeviceModal_Members_Remove": "Rimuovere il membro",
    "DeviceModal_Members_Search": "Cerca membri",
    "DeviceModal_Members_NoDeviceMembers": "Nessun membro del dispositivo",
    "DeviceModal_Members_NoAgentMembers": "Nessun membro agente",
    "DeviceModal_Members_DnisNumber": "Numero DNS",
    "DeviceModal_Members_AddDnis": "Aggiungi DNS",
    "DeviceModal_Members_AddDnisHotkey": "Aggiungi DNIS (Ctrl+Invio)",
    "DeviceModal_Members_NoDnisMembers": "Nessuna associazione DNIS",
    "DeviceModal_LinkedEntities_Loading": "Caricamento delle entità collegate…",
    "DeviceModal_LinkedEntities_Empty": "Nessuno",
    "DeviceModal_LinkedEntities_Section_Groups": "Iscrizioni a gruppi",
    "DeviceModal_LinkedEntities_Section_Users": "Utenti associati",
    "DeviceModal_LinkedEntities_Column_GroupId": "Gruppo",
    "DeviceModal_LinkedEntities_Column_Description": "Descrizione",
    "DeviceModal_LinkedEntities_Column_UserId": "Utente"
}